import {
  Outlet,
  createFileRoute,
  redirect,
  useChildMatches,
} from '@tanstack/react-router';
import { DebriefV2Chrome, DebriefV2StateProvider } from '@/features/debrief-v2';
import type { StageId } from '@/features/debrief-v2/shared/components/DebriefV2Chrome';

const STAGE_BY_ROUTE_ID: Record<string, StageId> = {
  '/_dashboard/interactions/debrief-v2/$id/describe': 'describe',
  '/_dashboard/interactions/debrief-v2/$id/gather': 'gather',
  '/_dashboard/interactions/debrief-v2/$id/match-points': 'match-points',
  '/_dashboard/interactions/debrief-v2/$id/deep-dive': 'deep-dive',
  '/_dashboard/interactions/debrief-v2/$id/lessons': 'lessons',
};

export const Route = createFileRoute('/_dashboard/interactions/debrief-v2/$id')(
  {
    beforeLoad: ({ location, params }) => {
      const isBaseRoute =
        location.pathname === `/interactions/debrief-v2/${params.id}` ||
        location.pathname === `/interactions/debrief-v2/${params.id}/`;
      if (isBaseRoute) {
        throw redirect({
          to: '/interactions/debrief-v2/$id/describe',
          params: { id: params.id },
          replace: true,
        });
      }
    },
    component: RouteComponent,
  }
);

function RouteComponent() {
  const { id } = Route.useParams();
  const activeStage = useActiveStage();

  return (
    <DebriefV2StateProvider sessionId={id}>
      <div className="min-h-screen flex flex-col bg-page-bg text-slate-900">
        <DebriefV2Chrome sessionId={id} activeStage={activeStage} />
        <Outlet />
      </div>
    </DebriefV2StateProvider>
  );
}

function useActiveStage(): StageId {
  const childMatches = useChildMatches();
  const childRouteId = childMatches.at(0)?.routeId;
  return (childRouteId && STAGE_BY_ROUTE_ID[childRouteId]) ?? 'describe';
}
